import React, { useEffect, useState } from "react";
import { Container, Image } from "react-bootstrap";
import { json, Link } from "react-router-dom";
import Navbar from "../Navbar";
import Footer from "../footer/footer";
// import homeCoverEn from "../../assets/update_img/web2.jpg";
// import homeCoverAr from "../../assets/update_img/web1.jpg";
import homeCover from "../../assets/newImg/banner.jpg";
// import aidmubarak from "../../assets/update_img/aidmubarak.jpg";
import ourPartnerAr from "../../assets/newImg/our-partners-ar.png";
import ourPartnerEn from "../../assets/newImg/our-partners.png";
import rideWithUsEn from "../../assets/rideWithUsEn.jpeg";
import rideWithUsAr from "../../assets/rideWithUsAr.jpeg";
import service1En from "../../assets/newImg/Place-an-order.jpg";
import service1Ar from "../../assets/newImg/place-an-order-ar.jpg";
import service2En from "../../assets/newImg/Track-Order-1.jpg";
import service2Ar from "../../assets/newImg/track-order-ar.jpg";
import service3En from "../../assets/newImg/Receive-oreder.jpg";
import service3Ar from "../../assets/newImg/Receive-oreder-ar.jpg";
import offer1 from "../../assets/newImg/restaurant.jpg";
import offer2 from "../../assets/newImg/ride.jpg";
import offer3 from "../../assets/newImg/service.jpg";
import offer4 from "../../assets/newImg/store.jpg";
// import service4En from "../../assets/newImg/Place-an-order.jpg";
// import service4Ar from "../../assets/newImg/place-an-order-ar.jpg";
// import service5En from "../../assets/newImg/Receive-oreder.jpg";
// import service5Ar from "../../assets/newImg/Receive-oreder-ar.jpg";
// import service6En from "../../assets/newImg/Track-Order-1.jpg";
// import service6Ar from "../../assets/newImg/track-order-ar.jpg";
import section4En from "../../assets/newImg/Feast-Your-Senses.jpg";
import section4Ar from "../../assets/newImg/Feast-Your-Senses.jpg";
import promocode from "../../assets/update_img/Promocode-edit.jpg";
import promocodeAr from "../../assets/update_img/Promocode-edit-ar.jpg";
import appleStoreIcon from "../../assets/apple_store_icon.png";
import googleStoreIcon from "../../assets/google_store_icon.png";
import partner_1 from "../../assets/partner_1.jpeg";
import partner_2 from "../../assets/partner_2.jpeg";
import partner_3 from "../../assets/partner_3.jpeg";
import partner_4 from "../../assets/partner_4.jpeg";
import partner_5 from "../../assets/partner_5.jpeg";
import partner_6 from "../../assets/partner_6.jpeg";
import partner01 from "../../assets/partner1.jpeg";
import partner02 from "../../assets/partner2.jpeg";
import partner03 from "../../assets/partner3.jpeg";
import partner04 from "../../assets/partner4.jpeg";
import partner05 from "../../assets/partner5.jpeg";
import partner06 from "../../assets/partner6.jpeg";
import partner1 from "../../assets/newImg/partner1.png";
import partner2 from "../../assets/newImg/partner2.png";
import partner3 from "../../assets/newImg/partner3.png";
import partner4 from "../../assets/newImg/partner4.png";
import partner5 from "../../assets/newImg/partner5.png";
import partner6 from "../../assets/newImg/partner6.png";
import partner7 from "../../assets/newImg/partner7.jpg";
import partner8 from "../../assets/newImg/partner8.png";
import partner9 from "../../assets/newImg/partner9.png";
import partner10 from "../../assets/newImg/partner10.png";
import partner11 from "../../assets/newImg/partner11.png";
import partner12 from "../../assets/newImg/partner12.jpg";
import partner13 from "../../assets/newImg/partner13.png";
import { useTranslation } from "react-i18next";
import cookies from "js-cookie";
import ImageSlider from "./../restaurants/slider";
import CountUpAnimation from "./countUpAnimation";
import { useDispatch } from "react-redux";
import { getFindHelpData } from "../../features/orders/orderSlice";

// https://demo-findhelp.store/api/settings/promo_for_site

function MainHomePage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const lng = cookies.get("i18next") || "en";
  const [activeSection, setActiveSection] = useState("start");
  const [findHelpData, setFindHelpData] = useState();
  const [dataPromoCode, setDataPromoCode] = useState("");

  const handleSectionClick = (section) => {
    setActiveSection(section);
  };
  const partnersArray = [
    { image: { url: partner_1 } },
    { image: { url: partner_2 } },
    { image: { url: partner_3 } },
    { image: { url: partner_4 } },
    { image: { url: partner_5 } },
    { image: { url: partner_6 } },
    { image: { url: partner01 } },
    { image: { url: partner02 } },
    { image: { url: partner03 } },
    { image: { url: partner04 } },
    { image: { url: partner05 } },
    { image: { url: partner06 } },
    { image: { url: partner1 } },
    { image: { url: partner2 } },
    { image: { url: partner3 } },
    { image: { url: partner4 } },
    { image: { url: partner5 } },
    { image: { url: partner6 } },
    { image: { url: partner7 } },
    { image: { url: partner8 } },
    { image: { url: partner9 } },
    { image: { url: partner10 } },
    { image: { url: partner11 } },
    { image: { url: partner12 } },
    { image: { url: partner13 } },
  ];
  useEffect(() => {
    dispatch(getFindHelpData()).then((res) => {
      setFindHelpData(res.payload.data);
    });
  }, [dispatch]);

  useEffect(() => {
    fetch("https://demo-findhelp.store/api/settings/promo_for_site")
      .then((response) => response.json())
      .then((json) => setDataPromoCode(json), console.log(json.value))
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  return (
    <Container fluid className="p-0">
      <Navbar />
      <Container
        fluid
        className="flex justify-center w-full bg-[#F0A8350D] px-0"
      >
        <Image
          className="w-[95%] h-auto mt-2 rounded-lg bg-cover bg-center"
          // src={lng === "en" ? homeCoverEn : homeCoverAr}
          src={homeCover}
        />
      </Container>
      <Container>
        <div className="flex flex-col items-center md:flex-row lg:flex-row lg:justify-between gap-5 w-full">
          <Link
            to="/partnerwithus"
            className="no-underline  md:h-[320px] w-full mt-5"
          >
            <Image
              className="rounded-xl h-full object-cover"
              src={lng === "en" ? ourPartnerEn : ourPartnerAr}
            />
          </Link>
          <Link
            to="/ridewithus"
            className="no-underline md:h-[320px] w-full mt-5"
          >
            <Image
              className="rounded-xl h-full w-full object-cover"
              src={lng === "en" ? rideWithUsEn : rideWithUsAr}
            />
          </Link>
        </div>
      </Container>
      <div className="flex justify-evenly mt-5">
        <button
          className={`px-4 py-2 mr-20 rounded-full text-black font-semibold transition-colors duration-300
          ${
            activeSection === "start"
              ? "bg-[#F0A835] text-white"
              : "bg-transparent border-2 border-solid border-[#F0A835]"
          }`}
          onClick={() => handleSectionClick("start")}
        >
          {t("get_started")}
        </button>
        <button
          className={`px-4 py-2 rounded-full text-black font-semibold transition-colors duration-300
          ${
            activeSection === "offer"
              ? "bg-[#F0A835] text-white"
              : "bg-transparent border-2 border-solid border-[#F0A835]"
          }`}
          onClick={() => handleSectionClick("offer")}
        >
          {t("what_we_offer")}
        </button>
      </div>
      <div className="flex flex-wrap justify-around my-10">
        {activeSection === "start" ? (
          <>
            <div className="flex flex-col items-center justify-center">
              <p className="font-bold">{t("place_an_order")}</p>
              <Image
                className="w-[20rem] h-auto rounded-[15px]"
                src={lng === "en" ? service1En : service1Ar}
              />
              <p className="w-[20rem] pb-5 text-center font-bold mb-0 pt-3">
                {t("place_an_order_desc")}
              </p>
            </div>
            <div className="flex flex-col items-center justify-center">
              <p className="font-bold">{t("track_order")}</p>
              <Image
                className="w-[20rem] h-auto rounded-[15px]"
                src={lng === "en" ? service2En : service2Ar}
              />
              <p className="w-[20rem] pb-5 text-center font-bold mb-0 pt-3">
                {t("track_order_desc")}
              </p>
            </div>
            <div className="flex flex-col items-center justify-center">
              <p className="font-bold">{t("receive_oreder")}</p>
              <Image
                className="w-[20rem] h-auto rounded-[15px]"
                src={lng === "en" ? service3En : service3Ar}
              />
              <p className="w-[20rem] pb-5 text-center font-bold mb-0 pt-3">
                {t("receive_oreder_desc")}
              </p>
            </div>
          </>
        ) : (
          <>
            <Link
              to={"/restaurants"}
              className="text-black flex flex-col items-center justify-center"
            >
              <p className="font-bold">{t("restaurants")}</p>

              <Image
                className="w-[20rem] h-fit rounded-[15px]"
                src={offer1}
                // src={lng === "en" ? service4En : service4Ar}
              />
              {/* <p className="w-[20rem] pb-5 text-center font-bold mb-0 pt-3">
                {t("place_an_order_desc")}
              </p> */}
            </Link>
            <Link
              to={"/ride-now"}
              className="text-black flex flex-col items-center justify-center"
            >
              <p className="font-bold">{t("rideLink")}</p>
              <Image
                className="w-[20rem] h-fit mb-0 rounded-[15px]"
                src={offer2}
                // src={lng === "en" ? service6En : service6Ar}
              />
              {/* <p className="w-[20rem] pb-5 text-center font-bold mb-0 pt-3">
                {t("track_order_desc")}
              </p> */}
            </Link>
            <Link
              to={"/services"}
              className="text-black flex flex-col items-center justify-center"
            >
              <p className="font-bold">{t("services")}</p>

              <Image className="w-[20rem] h-fit rounded-[15px]" src={offer3} />
              {/* <p className="w-[20rem] pb-5 text-center font-bold mb-0 pt-3">
                {t("receive_oreder_desc")}
              </p> */}
            </Link>
            <Link
              to={"/shops"}
              className="text-black flex flex-col items-center justify-center"
            >
              <p className="font-bold">{t("shops")}</p>

              <Image className="w-[20rem] h-fit rounded-[15px]" src={offer4} />
              {/* <p className="w-[20rem] pb-5 text-center font-bold mb-0 pt-3">
                {t("receive_oreder_desc")}
              </p> */}
            </Link>
          </>
        )}
      </div>
      <div className="w-full flex flex-wrap justify-center mt-24">
        <div className="mx-5">
          <p className="text-7xl font-semibold mb-4">
            {t("feast_your_senses")}
          </p>
          <p className="text-7xl font-semibold text-[#F0A835] mb-4">
            {t("fast_and _fresh")}
          </p>
          <div className="w-[50%] flex justify-around mb-5">
            <Link
              to="https://apps.apple.com/eg/app/findhelpapp/id1450736684"
              target="_blank"
            >
              <Image className="pr-2" src={appleStoreIcon} />
            </Link>
            <Link
              to="https://play.google.com/store/apps/details?id=com.extreme.help"
              target="_blank"
            >
              <Image src={googleStoreIcon} />
            </Link>
          </div>
        </div>
      </div>
      {/* <div className="flex flex-wrap justify-center items-center gap-[20px]">
        <div className="min-w-[500px] h-[500px]">
          <Image
            className="w-[100%] h-[100%]"
            src={lng === "en" ? section4En : section4Ar}
          />
        </div>
        <div className="relative w-[500px] min-w-[500px] h-[250px] ">
          <span className="absolute top-[60%] left-[42%] -translate-x-1/2 -translate-y-1/2 text-[18px] font-medium">
            {dataPromoCode.value}
          </span>
          <Image
            className="rounded-[15px] w-[100%] h-[100%]"
            src={lng === "en" ? promocode : promocodeAr}
          />
        </div>
      </div> */}
      {/* ////////////////////////////////////////////////////////////////////////////////// */}
      <div className="flex flex-wrap justify-center items-center gap-[20px] overflow-hidden">
        <div className="w-full max-w-[500px] h-[500px] overflow-hidden">
          <Image
            className="w-full h-full object-contain"
            src={lng === "en" ? section4En : section4Ar}
            alt="Section Image"
          />
        </div>
        <div className="relative w-full max-w-[500px] h-[250px] overflow-hidden">
          <span className="absolute top-[60%] left-1/2 -translate-x-1/2 -translate-y-1/2 text-[18px] font-medium">
            {dataPromoCode.value}
          </span>
          <Image
            className="rounded-[15px] w-full h-full" // object-contain
            src={lng === "en" ? promocode : promocodeAr}
            alt="Promo Code"
          />
        </div>
      </div>

      <div className="flex justify-center text-4xl mt-16 mb-10">
        <p className="font-bold">{t("some_of_our_partners")}</p>
      </div>
      <div className="h-auto">
        {partnersArray ? (
          <>
            <div className="flex justify-center items-center h-auto bg-gray-100 my-3">
              <ImageSlider
                images={partnersArray}
                interval={3000}
                // width="[70%]"
                // height="80"
                width="[50%]"
                height="30"
                isRTL={lng === "ar"}
              />
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
      {findHelpData ? (
        <>
          <div className="flex flex-wrap justify-evenly items-center h-fit mx-14 mb-5 py-3 rounded-lg bg-gradient-to-l from-[#F2B655] to-[#ffebc3]">
            <div className="flex flex-col items-center">
              <p className="text-4xl m-0">
                <CountUpAnimation
                  targetNumber={findHelpData.couriers}
                  duration={2000}
                />
                +
              </p>
              <p className="text-xl font-medium">{t("registered_riders")}</p>
            </div>
            <div className="vr hidden md:block lg:block" />
            <hr className="w-52 block md:hidden lg:hidden" />
            <div className="flex flex-col items-center">
              <p className="text-4xl m-0">
                <CountUpAnimation
                  targetNumber={findHelpData.orders}
                  duration={2000}
                />
                +
              </p>
              <p className="text-xl font-medium">{t("orders_delivered")}</p>
            </div>
            <div className="vr hidden md:block lg:block" />
            <hr className="w-52 block md:hidden lg:hidden" />
            <div className="flex flex-col items-center">
              <p className="text-4xl m-0">
                <CountUpAnimation
                  targetNumber={findHelpData.restaurants}
                  duration={2000}
                />
                +
              </p>
              <p className="text-xl font-medium">
                {t("restaurants_partnered")}
              </p>
            </div>
            <div className="vr hidden md:block lg:block" />
            <hr className="w-52 block md:hidden lg:hidden" />
            <div className="flex flex-col items-center">
              <p className="text-4xl m-0">
                <CountUpAnimation
                  targetNumber={findHelpData.products}
                  duration={2000}
                />
                +
              </p>
              <p className="text-xl font-medium">{t("food_items")}</p>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
      <Footer />
    </Container>
  );
}

export default MainHomePage;
